'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Actions


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _progressiveImageActions = require('./progressiveImageActions');

require('./ProgressiveImage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IMAGE_FADE_TIMEOUT = 300;

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        hasLoaded: state.getIn(['app', 'progressiveImages', ownProps.source])
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        onImageLoad: function onImageLoad() {
            dispatch((0, _progressiveImageActions.markImageAsLoaded)({ source: ownProps.source }));
            // If an onload callback is provided invoke it now
            ownProps.onImageLoadCb && ownProps.onImageLoadCb();
        }
    };
};

/**
 * Shows an image which progressively becomes better quality by first showing a thumbnail of the image,
 * and then, once the larger version has loaded, replaces the thumbnail with the full size image.
 *
 * NOTE: The component initially shows the source file because it would otherwise cause a flash of content when dragging
 * an element that has already loaded.
 * Now there will be a slight flash when the image has not yet loaded, but that's an acceptable trade off.
 */
var ProgressiveImageFACC = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(ProgressiveImageFACC, _React$Component);

    function ProgressiveImageFACC(props) {
        _classCallCheck(this, ProgressiveImageFACC);

        var _this = _possibleConstructorReturn(this, (ProgressiveImageFACC.__proto__ || Object.getPrototypeOf(ProgressiveImageFACC)).call(this, props));

        _this.fetchThenShowImage = function (source, onImageLoadFn) {
            _this.img = new Image();
            _this.img.src = source;
            _this.img.onload = function () {
                _this.setState({
                    initialLoad: false,
                    visibleSource: source
                });

                // Make sure the transparent fade has finished before switching the image
                (0, _lodash.delay)(function () {
                    return onImageLoadFn(source);
                }, IMAGE_FADE_TIMEOUT);
            };
        };

        _this.state = {
            initialLoad: true,
            visibleSource: props.source
        };
        return _this;
    }

    /**
     * When the component is added to the DOM, set the source to the thumbnail and then start fetching the full sized
     * image.
     */


    _createClass(ProgressiveImageFACC, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                source = _props.source,
                onImageLoad = _props.onImageLoad,
                hasLoaded = _props.hasLoaded;

            // Fetch the real source, and once it's loaded set its state

            !hasLoaded && this.fetchThenShowImage(source, onImageLoad);
        }

        /**
         * If the nextProps change the source, then fetch the new source and then replace it with the current source.
         */

    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.source !== this.props.source) {
                this.fetchThenShowImage(nextProps.source, nextProps.onImageLoad);
            }
        }

        /**
         * Remove callbacks when unmounted.
         */

    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.img) {
                this.img.onload = function () {
                    return null;
                };
            }
        }

        /**
         * Fetches the source and then replaces the state with that source.
         *
         * @param source {String} The URL of the source to retrieve.
         * @param onImageLoadFn {Function} The function to call when an image is loaded.
         */

    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                hasLoaded = _props2.hasLoaded,
                children = _props2.children;
            var _state = this.state,
                initialLoad = _state.initialLoad,
                visibleSource = _state.visibleSource;

            return children({ hideImage: initialLoad && !hasLoaded, visibleSource: visibleSource });
        }
    }]);

    return ProgressiveImageFACC;
}(_react2.default.Component)) || _class);


ProgressiveImageFACC.propTypes = {
    source: _propTypes2.default.string.isRequired,
    onImageLoad: _propTypes2.default.func,
    hasLoaded: _propTypes2.default.bool,
    children: _propTypes2.default.func
};

exports.default = ProgressiveImageFACC;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/images/progressiveImages/ProgressiveImageFACC.js
// module id = 705
// module chunks = 0